import type { JSX } from 'solid-js';

// A single hex in the Molecular Hive. Uses CSS clip-path for the shape
// (cheap, accessible, Capacitor-safe — no SVG filters).
// Size is driven by a CSS custom property so the parent controls density.

export type HexCellProps = {
  label: string;
  percentage: number;
  tone?: 'default' | 'active' | 'muted';
  title?: string;
};

export default function HexCell(props: HexCellProps): JSX.Element {
  const toneClass = () =>
    props.tone === 'active'
      ? 'bg-brand-moss text-white'
      : props.tone === 'muted'
        ? 'bg-brand-hex/50 text-brand-green/60'
        : 'bg-brand-hex text-brand-green';

  return (
    <div
      role="group"
      aria-label={`${props.label} ${props.percentage.toFixed(2)}%`}
      title={props.title}
      class={`relative flex-shrink-0 grid place-items-center w-[var(--hex-size,7rem)] h-[var(--hex-size,7rem)] ${toneClass()}`}
      style={{
        'clip-path':
          'polygon(25% 5%, 75% 5%, 100% 50%, 75% 95%, 25% 95%, 0% 50%)',
      }}
    >
      <div class="text-center leading-tight px-2">
        <div class="text-xs font-medium opacity-80">{props.label}</div>
        <div class="text-base font-display font-bold">{props.percentage.toFixed(2)}%</div>
      </div>
    </div>
  );
}
